<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'INTEGRATION.INTEGRATION' | translate }}</div>
                <div class="tools"></div>
            </div>
            <div class="card-body">

                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                      <a class="nav-link active" id="nav-settings-tab" data-toggle="tab" href="#nav-settings" role="tab" aria-controls="nav-settings" aria-selected="true">{{ 'SETTINGS' | translate }}</a>
                    </div>
                </nav>
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-settings" role="tabpanel" aria-labelledby="nav-settings-tab">

                        <br>
                        <ul class="list-group">
                            <li class="list-group-item" *ngFor="let retail of retails">
                                <div class="item-content">
                                    <a routerLink="/integration/settings/{{retail.id}}">
                                        <div>{{ retail.name[language] }}</div>
                                    </a>
                                </div>
                            </li>
                        </ul>

                    </div>

                </div>

            </div>
        </div>

    </div>
</div>